import { render, staticRenderFns } from "./hochat_game_config.vue?vue&type=template&id=4bf2300a&scoped=true"
import script from "./hochat_game_config.vue?vue&type=script&lang=js"
export * from "./hochat_game_config.vue?vue&type=script&lang=js"
import style0 from "./hochat_game_config.vue?vue&type=style&index=0&id=4bf2300a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf2300a",
  null
  
)

export default component.exports